import React from 'react';
import { motion } from 'framer-motion';

import Typewriter from 'typewriter-effect';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

// const scaleVariants = {
//   whileInView: {
//     scale: [0, 1],
//     opacity: [0, 1],
//     transition: {
//       duration: 1,
//       ease: 'easeInOut',
//     },
//   },
// };

const Header = () => (
  <div className="app__header_first app__flex ">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <h3 className='app__header-color-text'>Bonjour, je suis <span>Philippe</span></h3>
        <h1 className="head-text app__header-color-text">et un<Typewriter
            onInit={(typewriter) => {
              typewriter
              .typeString('Developpeur')
              .pauseFor(300)
              .deleteAll()
              .typeString('Designer')
              .pauseFor(300)
              .deleteAll()
              .typeString('Marketeur')
              .pauseFor(300)
              .start();
            }}
            options={{
              autoStart: true,
              loop: true,
            }}
        
        /></h1>
        {/* <p className="p-text app__header-color-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore vero, architecto qui ea sapiente fugit, delectus at rerum aliquid optio exercitationem error aperiam maxime autem.</p> */}
        <button className="p-text app__header-button" ><a href='#contact'>Me contacter</a></button>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.profile} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>
  </div>
);

export default AppWrap(Header, 'accueil','app__primarybg',);
